import { render, staticRenderFns } from "./ClientAdditional.vue?vue&type=template&id=337acc5c"
import script from "./ClientAdditional.vue?vue&type=script&lang=js"
export * from "./ClientAdditional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports